import {Component, Input} from '@angular/core';
import {AuthenticationService} from '../../services';
import {LogoutPositionEnum} from '@core/modules/authentication/components/logout/config/logout-position.enum';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  @Input() position: LogoutPositionEnum = LogoutPositionEnum.Center;

  constructor(private authService: AuthenticationService) {}

  public onLogout(): void {
    this.authService.logout();
  }
}
